var _defs, _g;

const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

const SvgIconNotOk = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{}.a{opacity:0;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-531 -523)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 16,
    height: 16,
    transform: "translate(531 523)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-11238.292-14615.636a1,1,0,0,1,0-1.413l1.415-1.414-1.415-1.415a1,1,0,0,1,0-1.416,1,1,0,0,1,1.413,0l1.417,1.415,1.412-1.412a1,1,0,0,1,1.413,0,1,1,0,0,1,0,1.413l-1.411,1.411,1.415,1.414a1.007,1.007,0,0,1,0,1.417,1.007,1.007,0,0,1-1.417,0l-1.414-1.415-1.415,1.415a.99.99,0,0,1-.706.294A.994.994,0,0,1-11238.292-14615.636Z",
    transform: "translate(11774.464 15149.463)"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconNotOk, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-not-ok.24ef6b0b.svg";
export { ForwardRef as ReactComponent };